import * as Sentry from '@sentry/react';

// Browser-only Sentry init for the landing site.
//
// CRITICAL: this must NEVER run during SSR or prerender. The prerender script
// imports entry-server.tsx, which never imports this file; entry-client.tsx
// is the only consumer, and the typeof window guard below is a belt-and-
// braces second line of defence (in case someone adds an SSR import later).
//
// Landing has no auth context — no tenant tagging, no PII scrubbing
// machinery. Sample rate is intentionally lower than the internal apps
// (default 0.05) because traffic is high and error density is low.
export function initSentry() {
  if (typeof window === 'undefined') return;
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0.05'),
    sendDefaultPii: false,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
export { Sentry };
